let timelineElements = [
  {
    id: 1,
    title: "University of Southern California, Los Angeles, USA",
    subtitle: "Computer Science Graduate Student",
    description: [
      "CSCI 570 Analysis of Algorithms ",
      "CSCI 571 Web Technologies",
    ],
    date: "August 2024 - present",
    icon: "school",
  },
  {
    id: 2,
    title: "BP, Pune, India",
    subtitle: "Software Engineer",
    description: [
      "Introduced micro frontend architecture via Webpack’s module federation.",
      "Optimized user creation with MSAL authentication, automating record generation upon landing.",
      "Enhanced backend test coverage from 36% to 82% using xUnit framework."
    ],
    date: "April 2023 - July 2024",
    icon: "work",
  },
  {
    id: 3,
    title: "Amazon, Bangalore, India",
    subtitle: "Software Development Engineer - 1",
    description: [
      "Achieved 2nd Runner-Up in Amazon internal Hackathon.",
      "Led launch of Spends Aggregation for account updates, integrating new entities for budget caps",
      "Improved code quality and efficiency through 50+ PR reviews, advocating code reuse and enhancing test coverage.",
    ],
    date: "November 2021 - November 2022",
    icon: "work",
  },
  {
    id: 4,
    title: "Schlumberger, Pune, India",
    subtitle: "Software Engineer",
    description: [
      "Cloud Hero Competition Winner (Schlumberger).",
      "Engineered user administration for 10+ distinct access levels in the Global Activity Capture (GAC) app.",
      "Resolved 30+ bugs across backend and frontend, enhancing stability and performance.",
    ],
    date: "September 2020 - October 2021",
    icon: "work",
  },
  {
    id: 5,
    title: "Army Institute of Technology, Pune, India",
    subtitle: "Bachelor's of Engineering in Computer Engineering",
    description:[
      "CGPA: 9.32/10",
      "Recipient of prestigious Tata Merit, AWES, and Bhadve Scholarships.",
      "1st Runner-Up at Rajkot Smart City Hackathon.",
      "Winner of Silhouettes (dance competitions) 2017 at AFMC.",
      "Champion of inter-branch choreography competitions (2017, 2018) at Army Institute of Technology."
    ],
    date: "June 2016 - July 2020",
    icon: "school",
  },
  {
    id: 6,
    title: "Army Public School, Lucknow, India",
    subtitle: "Higher Secondary Certificate",
    description: [
      "Percentage: 95%.",
      "Awards: Received the Academic Appreciation Certification from the Education Minister of India.",
    ],
    date: "2013-2015",
    icon: "school",
  },
  {
    id: 7,
    title: "Army Public School, Jhansi, India",
    subtitle: "Secondary School Certificate",
    description: [
      "CGPA: 9.8/10",
    ],
    date: "2012-2013",
    icon: "school",
  },
];
  
export default timelineElements;
